var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          class: ["guide-page", _vm.NODE_ENV === "erp-prod" ? "isErp" : ""],
          on: { click: _vm.doClose },
        },
        [
          _c("div", { staticClass: "steps" }, [
            _c(
              "div",
              { staticClass: "step", class: { "hide-step": _vm.hide } },
              [
                _c("div", {
                  staticClass: "step-bar",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.doStep(1)
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "step-tips",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " 点击圆圈开启圈选，标记中心点后松开鼠标，在地图上移动绘制范围（单击完成或ESC中断），可以看到这个范围的在营业企业哦~ "
                    ),
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { w100: "", type: "dialog-cancel" },
                            on: { click: _vm.doClose },
                          },
                          [_vm._v("跳过提醒")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { w100: "", type: "dialog-confirm" },
                            on: { click: _vm.doAlwaysClose },
                          },
                          [_vm._v("不再提醒")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }